import { useCallback } from 'react'
import { TargetPestDataType } from './useData'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'

export function useHandlers() {
  const { setFieldValue } = useFormikContext<
    ILeadFormModel | IAddOpportunityFormModel
  >()

  const handelChange = useCallback((value: TargetPestDataType[] | null) => {
    setFieldValue(
      'targetPests',
      value?.map((row) => row.value),
    )
  }, [])

  const handelFocus = useCallback(() => {
    setFieldValue('assignmentRuleFieldFocused', true)
  }, [setFieldValue])

  const handelBlur = useCallback(() => {
    setFieldValue('assignmentRuleFieldFocused', false)
  }, [setFieldValue])

  return {
    handelChange,
    handelFocus,
    handelBlur,
  }
}
